import script from "./editMedicDoseLower.vue?vue&type=script&setup=true&lang=ts"
export * from "./editMedicDoseLower.vue?vue&type=script&setup=true&lang=ts"

import "./editMedicDoseLower.vue?vue&type=style&index=0&id=ff90e6ea&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff90e6ea"]])

export default __exports__